import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1bccff",
        secondary: "#f44336",
        accent: "#606dc3",
        error: "#ff5722",
        warning: "#ff9800",
        info: "#607d8b",
        success: "#4caf50"
      }
    }
  },
  icons: {
    iconfont: "md"
  }
});
